import { wrapRootElement as wrapRoot } from './root-wrapper';
import { WrapPageElement as wrapPage } from './page-wrapper';
import shouldUpdateScroll from './shouldUpdateScroll';
import onClientEntry from './onClientEntry';

export const wrapRootElement = wrapRoot;
export const wrapPageElement = wrapPage;

export { onClientEntry, shouldUpdateScroll };
